import { Injectable } from '@angular/core';

// external libs
import { Observable, Subject } from 'rxjs';

// services
import { MapService } from './abstract-map';

// directives
import { H21MapMarkerClusterDirective } from '../../directives/h21-map-marker-cluster.directive';

// models
import { CircleEvent } from '../../models/circle-event.model';
import { Position } from '../../models/position.model';
import { MarkerClusterFilter } from '../../models/marker-cluster-filter.model';
import { ChangesMap } from '../../enums/changes-map.enum';
import { Bounds } from '../../models/bounds-map.model';

@Injectable()
export abstract class MarkerClusterService<T, U, N> {

    public map: MapService<T, U, N>;

    public addListener: Subject<boolean> = new Subject<boolean>();
    public markerClusterClick: Subject<any> = new Subject<any>();
    public loading: Subject<boolean> = new Subject<boolean>();
    public modeCircle: Subject<CircleEvent> = new Subject<CircleEvent>();
    public changeFilter: Subject<MarkerClusterFilter> = new Subject<MarkerClusterFilter>();
    public isMarkerCluster: Subject<any> = new Subject<any>();
    public ready$: Subject<void> = new Subject<void>();
    public redraw$: Subject<void> = new Subject<void>();
    public changeTrackMap$: Subject<ChangesMap> = new Subject<ChangesMap>();
    public resizeBounds$: Subject<Bounds> = new Subject<Bounds>();
    public clearMarkerCluster$: Subject<void> = new Subject<void>();
    public countLoadMarkers$: Subject<number> = new Subject<number>();

    public initMap(map: MapService<T, U, N>): void {
        this.map = map;
    }

    public abstract addMarkerCluster(layer?: H21MapMarkerClusterDirective, geoJson?: any): void;

    public abstract removeMarkerClusters(): void;

    public abstract removeMarkerCluster(layer: H21MapMarkerClusterDirective): void;

    public abstract removeFeature(layer: H21MapMarkerClusterDirective): void;

    public abstract createEvent<E>(eventName: string, layer: H21MapMarkerClusterDirective): Observable<E>;

    public abstract createEventMouseOver<D>(layer: H21MapMarkerClusterDirective): Observable<D>;

    public abstract createEventMouseOut<D>(layer: H21MapMarkerClusterDirective): Observable<D>;

    public abstract createEventMouseClick<DE>(layer: H21MapMarkerClusterDirective): Observable<DE>;

    public abstract updateMarkerCluster<DE>(layer: H21MapMarkerClusterDirective): void;

    public abstract setModeCircle(CircleOptions: CircleEvent): void;

    public abstract setFilter(filter: MarkerClusterFilter): void;

    public abstract updateStyle(featureId: number, position?: Position): void;

    public abstract getBounds(): Observable<any>;

    public abstract clearMarkerCluster(): void;

    public redraw(): void {
        this.changeFilter.next(null);
    }

    public setChangeMap(mode: ChangesMap): void {
        this.changeTrackMap$.next(mode);
    }

    public resizeBounds(bounds?: Bounds): void {
        this.resizeBounds$.next(bounds);
    }

    public getCountLoadMarkers(layer: H21MapMarkerClusterDirective): void {
        let countLoad = 0;
        if (!layer.geoJson) { return; }
        const geoJson = { ...layer.geoJson };
        geoJson.features.forEach((feature) => {
            if (feature.number) { countLoad += feature.number; }
        });
        geoJson.features = geoJson.features.filter((item: any) => item.properties.iconUrl !== undefined);
        { countLoad += geoJson.features.length; }
        this.countLoadMarkers$.next(countLoad);
    }


}
